const ASYNC = {
	inProgress: false,
};

const ASYNC_ACTIONS = {
	SET_PROGRESS: 'SET_PROGRESS',
};

const MEME = {
	saved: false,
	offset: 0,
	images: {
		default: undefined,
		overlay: undefined,
		user: undefined,
	},
	rotation: 0,
	fields: [
		{
			location: { x: 0, y: 0, width: 0 },
			text: '',
			maxLength: 0,
			id: '',
		},
	],
};

const MEME_ACTIONS = {
	SET_CONFIG: 'SET_CONFIG',
	SET_USER_IMAGE: 'SET_USER_IMAGE',
	ROTATE_USER_IMAGE: 'ROTATE_USER_IMAGE',
	SET_TEXT: 'SET_TEXT',
	SET_SAVED: 'SET_SAVED',
	SET_OFFSET: 'SET_OFFSET',
};

export { ASYNC, ASYNC_ACTIONS, MEME, MEME_ACTIONS };



// WEBPACK FOOTER //
// ./src/js/components/model/models.js